import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';
import Icon from '../../Icon';
import Dropdown from '@afosto/components-react/Dropdown';
import formatBytes from '@afosto/utils/string/formatBytes';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import getFontAwesomeFileIcon from '@afosto/utils-react/files/getFontAwesomeFileIcon';

const File = ({ actions, file }) => (
  <Box>
    <ListItem component="div" dense>
      {file.type === 'image' ? (
        <ListItemAvatar>
          <Avatar src={file.url} />
        </ListItemAvatar>
      ) : (
        <ListItemIcon>
          <Icon icon={['fal', getFontAwesomeFileIcon(file.mime)]} color="primary" size="large" />
        </ListItemIcon>
      )}
      <ListItemText
        primary={file.filename}
        primaryTypographyProps={{ variant: 'body2', style: { wordBreak: 'break-all' } }}
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          <Box display="flex" flexDirection="column" mt={0.5}>
            <Typography variant="caption" color="textSecondary">
              {formatDateTime(file?.updatedAt)}
            </Typography>
            <Typography variant="caption">
              {file?.fileSize ? formatBytes(file?.fileSize) : '-'}
            </Typography>
          </Box>
        }
      />
      <ListItemSecondaryAction>
        <Dropdown position="bottom-end" disablePortal={false} items={actions} />
      </ListItemSecondaryAction>
    </ListItem>
  </Box>
);

File.propTypes = {
  actions: PropTypes.array,
  file: PropTypes.object,
};

File.defaultProps = {
  actions: [],
  file: undefined,
};

export default File;
